import Vue from "vue";
import VueRouter from "vue-router";
import { Message } from "element-ui";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "@/store";
import util from "@/libs/util.js";
import routes from "./routes"; // 确保这是你之前提供的路由配置

Vue.use(VueRouter);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err);
};
const routerReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function (location) {
  return routerReplace.call(this, location).catch(err => err);
};

// 初始化路由信息
store.commit("d2admin/router/init", routes);

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  routes,
});

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace;

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err);
}

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
  const route = store.state.d2admin.router.flatRouteList[to.name] || {}; // 当前路由信息
  const menuNameList = store.state.d2admin.router.menuNameList || []; // 菜单列表
  const token = util.cookies.get("token"); // token

  NProgress.start(); // 进度条开启
  store.commit("d2admin/search/set", false); // 关闭搜索面板
  if (route.meta?.pass) {
    next();
  } else if (token && token !== "undefined" && menuNameList.length) {
    if (route.meta?.hidden || route.meta?.auth) {
      next();
    } else {
      // 只有在首次访问且没有目标路由时才跳转到首页
      // 刷新页面时保持当前页面
      if (!from.name && !to.name) {
        next({
          name: menuNameList[0] || "/",
        });
      }else{
        next();
      }
    }
  } else {
    if (from.name !== "login") {
      next({
        name: "login",
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      next(false);
    }
  }
  NProgress.done(); // 进度条关闭
});

// 在路由加载完成后初始化固定标签
router.onReady(() => {
  store.dispatch("d2admin/tagsView/initAffixTags");

  // 添加当前路由（处理刷新页面时）
  const { name, meta } = router.currentRoute;
  if (name && !meta.hidden) {
    store.dispatch("d2admin/tagsView/addView", router.currentRoute);
  }
});

router.afterEach((to) => {
  // 进度条
  NProgress.done();
  // 多页控制 打开新的页面
  store.dispatch("d2admin/page/open", to);
  // 更改标题
  util.title(to.meta.title);
});

export default router;
